// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"client_app_modules_auth_auth_module_ts":"8c8b41bf3736485c","client_app_modules_audit_audit_module_ts":"5152e89c6ff5dcc4","client_app_modules_search_search_module_ts":"ab091d0591392c42","client_app_scripts_jsdifflib_index_js":"2324bbf3c387f66c"}[chunkId] + ".js";
};